import { g as a } from "./use-maps-token.mGyQNmhc.js";
import { H as s, f as n } from "./fetcher.CPHInLJD.js";
const p = async (o) => {
  const e = await a();
  if (!e)
    throw new s("Azure Maps Error", "No token available", 401);
  const r = {
    Authorization: `Bearer ${e}`
  }, t = process.env.NEXT_PUBLIC_AZURE_MAPS_CLIENT_ID;
  return t && (r["x-ms-client-id"] = t), n(o, { headers: r });
};
export {
  p as m
};
